import { gql } from 'graphql-tag'
import { settingsFragment } from '../../admin/station/stationSettings/settingsQueries'

export const fetchReportMonthlyWastage = gql`
  query fetchReportMonthlyWastage(
    $stationId: ID!
    $type: ProductType!
    $productType: String!
    $year: Int!
    $month: Int!
  ) {
    reportMonthlyWastage(stationId: $stationId, type: $type, year: $year, month: $month) {
      week
      date
      type
      wastageVolume
      wastageAmount
      salesAmount
      salesVolume
      note
    }
    getWastageBoundariesForProductType(stationId: $stationId, productType: $productType) {
      id
      productType
      lowerWastageBounds
      upperWastageBounds
    }
    stationSettings(stationId: $stationId) {
      ...SettingsFragment
    }
  }
  ${settingsFragment}
`
